import React from "react"
import ReactDOM from "react-dom"
import { createStore } from "redux"
import { Provider } from "react-redux"

import * as serviceWorker from "./serviceWorker"
import App from "./app"
import rootReducer from "./redux"
import Facebook from "./shared/facebook"
import GoogleAnalytics from "./shared/googleAnalytics"

import "./style/index.scss"

export const store = createStore(rootReducer)

const Maintenance = () => (
  <div style={{ paddingTop: 40, textAlign: "center" }}>
    Maintenance en cours ...
  </div>
)

const Index = () => (
  <Provider store={store}>
    <App />
    <Facebook />
    <GoogleAnalytics />
  </Provider>
)

ReactDOM.render(<Index />, document.getElementById("root"))

serviceWorker.unregister()
